(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-sl-ready') === '1') return;
    root.setAttribute('data-sl-ready', '1');
    var list = root.querySelector('[data-sl-revlist]');
    var wrap = root.querySelector('[data-sl-more-wrap]');
    var btn = root.querySelector('[data-sl-more]');
    if (!list || !wrap || !btn) return;
    var rest = root.querySelector('template[data-sl-revrest]');
    var cards = Array.prototype.slice.call(list.children);
    var total = cards.length + (rest ? rest.content.children.length : 0);
    var desk = window.matchMedia && window.matchMedia('(min-width: 900px)').matches;
    var step = parseInt(root.getAttribute(desk ? 'data-initial' : 'data-initial-mobile'), 10) || 4;
    var shown = Math.min(step, total);
    function paint() {
      // Move the cards needed next out of the template, so only what is shown becomes live DOM
      while (rest && cards.length < shown && rest.content.firstElementChild) {
        var c = rest.content.firstElementChild;
        list.appendChild(c);
        cards.push(c);
      }
      cards.forEach(function (c, i) { c.hidden = i >= shown; });
      wrap.hidden = shown >= total;
    }
    btn.addEventListener('click', function () {
      var first = shown;
      shown = Math.min(total, shown + step);
      paint();
      var next = cards[first];
      if (next) { next.setAttribute('tabindex', '-1'); next.focus({ preventScroll: true }); }
    });
    paint();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sl-rev]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-sl-ready') === '1') return;
    root.setAttribute('data-sl-ready', '1');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sl-vitem]'));
    var all = [];
    var soundOn = false;
    var sounds = [];
    items.forEach(function (item) {
      var v = item.querySelector('[data-sl-video]');
      var btn = item.querySelector('[data-sl-play]');
      if (!v || !btn) return;
      all.push(v);
      var label = btn.getAttribute('data-label') || 'video';
      function paint(playing) {
        item.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        btn.setAttribute('aria-label', (playing ? 'Pause video: ' : 'Play video: ') + label);
      }
      btn.addEventListener('click', function () {
        if (v.paused) {
          all.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
          v.muted = !soundOn;
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () { paint(false); });
        } else {
          v.pause();
        }
      });
      var sb = item.querySelector('[data-sl-sound]');
      if (sb) {
        sounds.push(sb);
        sb.addEventListener('click', function (e) {
          e.stopPropagation();
          soundOn = !soundOn;
          all.forEach(function (o) { o.muted = !soundOn; });
          sounds.forEach(function (b) { b.setAttribute('aria-pressed', soundOn ? 'true' : 'false'); b.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on'); });
        });
      }
      v.addEventListener('play', function () { paint(true); });
      v.addEventListener('pause', function () { paint(false); });
      v.addEventListener('ended', function () { paint(false); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) return;
          var v = e.target.querySelector('[data-sl-video]');
          if (v && !v.paused) v.pause();
        });
      }, { threshold: 0.2 });
      items.forEach(function (i) { io.observe(i); });
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sl-vid]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__swHeaderInit) return;
    window.__swHeaderInit = true;

    var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');

    function closeDropdown(btn, focusBtn) {
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      if (focusBtn) btn.focus();
    }
    function openDropdown(btn) {
      document.querySelectorAll('[data-sw-dd-toggle][aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) closeDropdown(other);
      });
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }
    var lastOpener = null;
    function closeDrawer(d) {
      if (typeof d.close === 'function' && !d.classList.contains('sw-header__drawer--fallback')) { d.close(); return; }
      d.removeAttribute('open');
      d.classList.remove('sw-header__drawer--fallback');
      document.documentElement.classList.remove('sw-drawer-open');
      if (lastOpener) { lastOpener.setAttribute('aria-expanded', 'false'); lastOpener.focus(); lastOpener = null; }
    }
    function closeAll() {
      document.querySelectorAll('[data-sw-dd-toggle][aria-expanded="true"]').forEach(function (b) { closeDropdown(b); });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var toggle = t.closest('[data-sw-dd-toggle]');
      if (toggle) {
        /* Opened a moment ago by hover: a click keeps it open instead of closing it. */
        if (toggle.dataset.swHoverOpen) { delete toggle.dataset.swHoverOpen; openDropdown(toggle); return; }
        if (toggle.getAttribute('aria-expanded') === 'true') closeDropdown(toggle);
        else openDropdown(toggle);
        return;
      }
      if (!t.closest('.sw-header__dropdown')) closeAll();

      var opener = t.closest('[data-sw-drawer-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('aria-controls'));
        if (!dlg) return;
        if (typeof dlg.showModal === 'function') {
          dlg.showModal();
          dlg.addEventListener('close', function () { opener.setAttribute('aria-expanded', 'false'); }, { once: true });
        } else {
          /* No <dialog> support (iOS < 15.4): open it as a fixed panel */
          dlg.setAttribute('open', '');
          dlg.classList.add('sw-header__drawer--fallback');
          document.documentElement.classList.add('sw-drawer-open');
          lastOpener = opener;
          var closeBtn = dlg.querySelector('[data-sw-drawer-close]');
          if (closeBtn) closeBtn.focus();
        }
        opener.setAttribute('aria-expanded', 'true');
        return;
      }
      if (t.closest('[data-sw-drawer-close]')) {
        var d = t.closest('[data-sw-drawer]');
        if (d) closeDrawer(d);
        return;
      }
      /* Fallback panel: a click outside it closes it */
      var fb = document.querySelector('.sw-header__drawer--fallback[open]');
      if (fb && !fb.contains(t)) closeDrawer(fb);
      /* Click on the dialog backdrop closes it */
      if (t.matches('dialog[data-sw-drawer]')) {
        var r = t.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
      }

      /* Search: open Horizon's predictive search modal when it exists, else follow the /search link */
      var search = t.closest('[data-sw-search]');
      if (search) {
        var modal = document.getElementById('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          e.preventDefault();
          modal.showDialog();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var fbOpen = document.querySelector('.sw-header__drawer--fallback[open]');
      if (fbOpen) { closeDrawer(fbOpen); return; }
      var open = document.querySelector('[data-sw-dd-toggle][aria-expanded="true"]');
      if (open) closeDropdown(open, true);
    });

    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      document.querySelectorAll('[data-sw-dd-toggle][aria-expanded="true"]').forEach(function (btn) {
        var item = btn.closest('.sw-header__item');
        if (item && !item.contains(t)) closeDropdown(btn);
      });
    });

    function bindHover(root) {
      (root || document).querySelectorAll('.sw-header__item--parent').forEach(function (item) {
        if (item.dataset.swHover) return;
        item.dataset.swHover = '1';
        var timer;
        var btn = item.querySelector('[data-sw-dd-toggle]');
        item.addEventListener('mouseenter', function () {
          if (!hoverMQ.matches) return;
          clearTimeout(timer);
          if (btn.getAttribute('aria-expanded') !== 'true') btn.dataset.swHoverOpen = '1';
          openDropdown(btn);
        });
        item.addEventListener('mouseleave', function () {
          if (!hoverMQ.matches) return;
          timer = setTimeout(function () { delete btn.dataset.swHoverOpen; closeDropdown(btn); }, 180);
        });
      });
    }
    bindHover();
    document.addEventListener('shopify:section:load', function (e) { bindHover(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Horizon locks html/body on desktop and scrolls .page-wrapper instead, so window.scrollTo does nothing there.
    // scrollIntoView scrolls whichever ancestor actually scrolls; scroll-margin-top keeps it clear of the sticky header.
    function scrollToEl(el) {
      if (!el) return;
      try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      catch (e) { el.scrollIntoView(true); }
    }

    function initGallery(root) {
      var track = root.querySelector('[data-sw-track]');
      if (!track) return null;
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sw-thumb]'));
      var counter = root.querySelector('[data-sw-count]');
      var prev = root.querySelector('[data-sw-prev]');
      var next = root.querySelector('[data-sw-next]');
      var index = 0;
      var ticking = false;

      function setActive(i) {
        index = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (counter) counter.textContent = String(i + 1);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      function go(i) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        setActive(i);
      }
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== index) setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-sw-thumb'), 10) || 0); });
      });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      return {
        toMedia: function (id) {
          if (!id) return;
          for (var k = 0; k < slides.length; k++) {
            if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return; }
          }
        }
      };
    }

    function init(root) {
      if (!root || root.getAttribute('data-sw-ready') === '1') return;
      root.setAttribute('data-sw-ready', '1');
      var gallery = initGallery(root);
      var form = root.querySelector('form.sw-product__form') || root.querySelector('[data-sw-form]');
      var idInput = form ? form.querySelector('[data-sw-id]') : null;
      var radios = Array.prototype.slice.call(root.querySelectorAll('.sw-offer__input'));
      // Without JS the checked radio posts name="id". With JS, the hidden input carries the id (express checkout reads it),
      // so the radios get their own group name back and the hidden input is enabled.
      if (idInput && radios.length) {
        radios.forEach(function (r) { r.setAttribute('name', r.getAttribute('data-sw-group') || 'sw-variant'); });
        idInput.disabled = false;
      }
      var bar = root.querySelector('[data-sw-buybar]');

      function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

      function apply(r, opts) {
        if (!r) return;
        var d = r.dataset;
        if (idInput) {
          idInput.value = r.value;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        each('[data-sw-price]', function (el) { el.textContent = d.price || ''; });
        each('[data-sw-unit]', function (el) { el.textContent = d.unit || ''; el.hidden = !d.unit; });
        each('[data-sw-ship]', function (el) {
          el.textContent = d.ship || '';
          el.hidden = !d.ship;
          el.classList.toggle('is-free', d.shipFree === 'true');
        });
        each('[data-sw-variant-name]', function (el) { el.textContent = d.name || ''; });
        var available = d.available === 'true';
        each('[data-sw-add]', function (el) { el.disabled = !available; });
        each('[data-sw-add-label]', function (el) { el.textContent = available ? (d.label || 'Add to cart') : 'Sold out'; });
        each('.sw-offer', function (card) { card.classList.toggle('is-selected', card.contains(r)); });
        if (!(opts && opts.silent)) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', r.value);
            window.history.replaceState(window.history.state, '', url.toString());
          } catch (e) {}
          if (gallery && d.media) gallery.toMedia(d.media);
        }
      }

      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) apply(r); });
      });
      var checked = radios.filter(function (r) { return r.checked; })[0];
      if (checked) apply(checked, { silent: true });

      // In-page links from the buy box (#reviews, #safety...): if no element has that id, jump to the matching
      // Stillwell section by class (e.g. .sw-reviews), so they work whatever the section ids are.
      root.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (!a) return;
        var id = a.getAttribute('href').slice(1);
        if (!id || id === 'sw-buy' || document.getElementById(id)) return;
        var target = document.querySelector('.sw-' + id.replace(/[^a-z0-9_-]/gi, ''));
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
      });

      // Links like "?variant=123#sw-buy" on this same product page: select the variant and scroll, no reload.
      document.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a[href*="#sw-buy"]') : null;
        if (!a) return;
        var url;
        try { url = new URL(a.href, window.location.href); } catch (err) { return; }
        if (url.pathname !== window.location.pathname) return;
        e.preventDefault();
        var vid = url.searchParams.get('variant');
        if (vid) {
          var target = radios.filter(function (r) { return r.value === vid; })[0];
          if (target && !target.disabled) { target.checked = true; apply(target); }
        }
        var box = root.querySelector('#sw-buy');
        if (box) scrollToEl(box);
      });

      var watch = bar ? root.querySelector('[data-sw-buy-target]') : null;
      if (bar && watch) {
        var shown = null;
        var setBar = function (show) {
          if (show === shown) return;
          shown = show;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
          document.documentElement.classList.toggle('sw-buybar-on', show);
        };
        // Visible only once the main button has scrolled ABOVE the viewport (not before reaching it).
        var check = function () { setBar(watch.getBoundingClientRect().bottom < 0); };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            var e = entries[0];
            setBar(!e.isIntersecting && e.boundingClientRect.bottom < 0);
          }, { threshold: 0 }).observe(watch);
        }
        // Jumps (anchor links, restored scroll) can skip the observer; a light scroll check covers them.
        var queued = false;
        window.addEventListener('scroll', function () {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(function () { queued = false; check(); });
        }, { passive: true });
        check();
      }
    }

    function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sw-product]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-sw-product]') : null;
      if (el) init(el);
    });
    document.addEventListener('shopify:section:unload', function () { document.documentElement.classList.remove('sw-buybar-on'); });
  })();

  } catch(e) { console.error(e); }
})();
})();
